import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Check, Truck, ShieldCheck, RefreshCw } from "lucide-react";
import { api, brl } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductDetail() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [size, setSize] = useState(null);
  const { add } = useCart();

  useEffect(() => {
    setProduct(null);
    api.get(`/products/${slug}`).then((r) => { setProduct(r.data); setSize(r.data.sizes?.[0] || null); }).catch(() => {});
  }, [slug]);

  if (!product) return <div className="h-[70vh] flex items-center justify-center text-white/40">Carregando...</div>;

  const handleAdd = () => {
    if (product.sizes?.length > 1 && !size) { toast.error("Selecione um tamanho."); return; }
    add(product, size);
    toast.success(`${product.name} adicionado à sacola.`);
  };

  return (
    <div data-testid="product-detail-page" className="max-w-[1600px] mx-auto px-5 md:px-10 py-12">
      <Link to="/loja" className="inline-flex items-center gap-2 label-caps text-white/50 hover:text-rose transition-colors duration-300 mb-8"><ArrowLeft size={14} /> Voltar à loja</Link>
      <div className="grid md:grid-cols-2 gap-6 md:gap-16">
        <motion.div initial={{ opacity: 0, scale: 1.03 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="bg-surface2 overflow-hidden aspect-[3/4]">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        </motion.div>

        <div className="flex flex-col justify-center">
          <p className="label-caps text-rose mb-3">{product.category} · {product.collection}</p>
          <h1 className="font-serif-display font-light text-white text-4xl md:text-6xl tracking-tight leading-none">{product.name}</h1>
          <p className="font-serif-display text-3xl text-white mt-6">{brl(product.price)}</p>
          <p className="text-white/40 text-sm mt-1">ou até 12x de {brl(Math.round(product.price / 12))} no cartão</p>
          <p className="text-white/60 font-light leading-relaxed mt-8 max-w-lg">{product.desc}</p>

          <div className="mt-8">
            <p className="label-caps text-white/50 mb-3">Tamanho</p>
            <div className="flex flex-wrap gap-3">
              {product.sizes?.map((s) => (
                <button key={s} onClick={() => setSize(s)} data-testid={`size-${s}`}
                  className={`min-w-[52px] px-4 py-3 border text-sm transition-colors duration-300 ${size === s ? "border-rose text-rose" : "border-line text-white/70 hover:border-white"}`}>
                  {s}
                </button>
              ))}
            </div>
          </div>

          <button onClick={handleAdd} data-testid="add-to-cart-button"
            className="mt-10 bg-rose hover:bg-rose-hover text-ink font-bold py-4 label-caps flex items-center justify-center gap-3 transition-colors duration-300">
            <Check size={16} /> Adicionar à Sacola
          </button>

          <div className="grid grid-cols-3 gap-4 mt-10 border-t border-line pt-8">
            {[[Truck, "Entrega Brasil"], [ShieldCheck, "Compra Segura"], [RefreshCw, "Trocas Fáceis"]].map(([Icon, t]) => (
              <div key={t} className="text-center">
                <Icon size={20} className="text-rose mx-auto mb-2" />
                <p className="text-white/50 text-xs">{t}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
